export function OutlineQuestionCircleIcon({
  width = 24,
  height = 24,
  fill = 'none',
  stroke = 'currentColor',
  strokeWidth = 2,
}: React.SVGProps<SVGSVGElement>) {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 24 24"
      fill={fill}
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M12.0146 21C16.9852 21 21.0146 16.9706 21.0146 12C21.0146 7.02944 16.9852 3 12.0146 3C7.04409 3 3.01465 7.02944 3.01465 12C3.01465 16.9706 7.04409 21 12.0146 21Z"
        stroke={stroke}
        strokeWidth={strokeWidth}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M12.0146 12V14.0016"
        stroke={stroke}
        strokeWidth={strokeWidth}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M9.51392 9.49885C9.51392 8.11645 10.6323 6.99805 12.0147 6.99805C13.3971 6.99805 14.5155 8.11645 14.5155 9.49885C14.5155 10.8812 13.3971 11.9996 12.0147 11.9996"
        stroke={stroke}
        strokeWidth={strokeWidth}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M12.0146 17.0265V16.9785"
        stroke={stroke}
        strokeWidth={strokeWidth}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}
